import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { ReactNode } from 'react'

interface ModalBodyProps {
    children: ReactNode
    gradientStyle?: BuildGradientStyle
    id?: string
}

export const BonusModalBody = ({ children, gradientStyle, id }: ModalBodyProps) => {
    return (
        <div style={gradientStyle} className="-m-px" id={id}>
            {children}
        </div>
    )
}
